/** The per-IP flags of a region or exchange IP (SKY-4605, SKY-4938). */
const IP_FLAG_KEYS = ['isMonitoring', 'isApi', 'isTrading'] as const;

type IpFlagKey = (typeof IP_FLAG_KEYS)[number];

/**
 * Copies the flags an IP update sends onto a cached IP, for an optimistic
 * update of an IP list: a flipped switch shows its new state before the
 * refetch. Only the flags: a description is normalised by the backend, so the
 * list keeps showing the stored one until the refetch.
 */
export function applyIpFlagUpdate(
  ip: Record<IpFlagKey, boolean>,
  update: Partial<Record<IpFlagKey, boolean>>,
): void {
  for (const key of IP_FLAG_KEYS) {
    const value = update[key];
    if (value !== undefined) {
      ip[key] = value;
    }
  }
}
